import { render, staticRenderFns } from "./ReservationMemberCard.vue?vue&type=template&id=25c65072&scoped=true"
import script from "./ReservationMemberCard.vue?vue&type=script&lang=js"
export * from "./ReservationMemberCard.vue?vue&type=script&lang=js"
import style0 from "./ReservationMemberCard.vue?vue&type=style&index=0&id=25c65072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c65072",
  null
  
)

export default component.exports